import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Checkbox: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className = '',
  ...props
}) => {
  const isChecked = className.includes('checked')
  const isFirstRender = React.useRef(true)

  React.useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
    }
  }, [])

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M20.75 12C20.75 14.2604 20.7486 15.8804 20.583 17.1123C20.4406 18.1714 20.1861 18.8571 19.7676 19.3691L19.5781 19.5781C19.0451 20.1111 18.3225 20.4203 17.1123 20.583C15.8804 20.7486 14.2604 20.75 12 20.75C9.73963 20.75 8.1196 20.7486 6.8877 20.583C5.8286 20.4406 5.14288 20.1861 4.63086 19.7676L4.42188 19.5781C3.88886 19.0451 3.57972 18.3225 3.41699 17.1123C3.25137 15.8804 3.25 14.2604 3.25 12C3.25 9.73965 3.25137 8.11961 3.41699 6.8877C3.57972 5.67749 3.88887 4.95492 4.42188 4.42188L4.63086 4.23242C5.14289 3.81395 5.82858 3.5594 6.8877 3.41699C8.1196 3.25137 9.73963 3.25 12 3.25C14.2604 3.25 15.8804 3.25137 17.1123 3.41699C18.3225 3.57972 19.0451 3.88888 19.5781 4.42188L19.7676 4.63086C20.186 5.1429 20.4406 5.8286 20.583 6.8877C20.7486 8.11961 20.75 9.73965 20.75 12ZM22.25 12C22.25 9.78228 22.2515 8.04351 22.0693 6.68848C21.8958 5.3979 21.5452 4.3566 20.7949 3.52441L20.6387 3.36133C19.7804 2.50316 18.6882 2.11574 17.3115 1.93066C15.9565 1.74854 14.2177 1.75 12 1.75C9.78227 1.75 8.0435 1.74854 6.68848 1.93066C5.3979 2.10417 4.35658 2.45481 3.52441 3.20508L3.36133 3.36133C2.50315 4.21955 2.11575 5.31182 1.93066 6.68848C1.74854 8.04351 1.75 9.78228 1.75 12C1.75 14.2177 1.74854 15.9565 1.93066 17.3115C2.11575 18.6882 2.50313 19.7805 3.36133 20.6387L3.52441 20.7949C4.35658 21.5452 5.39791 21.8958 6.68848 22.0693C8.0435 22.2515 9.78227 22.25 12 22.25C14.2177 22.25 15.9565 22.2515 17.3115 22.0693C18.6882 21.8843 19.7804 21.4969 20.6387 20.6387L20.7949 20.4756C21.5452 19.6434 21.8958 18.6021 22.0693 17.3115C22.2515 15.9565 22.25 14.2177 22.25 12Z'
        fill={fill}
      />
      {isChecked ? (
        <path
          className={'fade-in'}
          d='M15.5019 8.43945C15.7858 8.18662 16.2206 8.18486 16.5068 8.44726C16.793 8.70964 16.8287 9.14256 16.6016 9.44726L16.5527 9.50683L11.0527 15.5068C10.9146 15.6575 10.721 15.7455 10.5166 15.75C10.3376 15.7539 10.1639 15.6932 10.0264 15.581L9.96972 15.5303L7.46972 13.0303L7.41796 12.9736C7.17765 12.679 7.19512 12.2443 7.46972 11.9697C7.74433 11.6951 8.17905 11.6777 8.47363 11.918L8.53027 11.9697L10.4756 13.915L15.4473 8.49316L15.5019 8.43945Z'
          fill={fill}
        />
      ) : !isFirstRender.current ? (
        <path
          className={'fade-out'}
          d='M15.5019 8.43945C15.7858 8.18662 16.2206 8.18486 16.5068 8.44726C16.793 8.70964 16.8287 9.14256 16.6016 9.44726L16.5527 9.50683L11.0527 15.5068C10.9146 15.6575 10.721 15.7455 10.5166 15.75C10.3376 15.7539 10.1639 15.6932 10.0264 15.581L9.96972 15.5303L7.46972 13.0303L7.41796 12.9736C7.17765 12.679 7.19512 12.2443 7.46972 11.9697C7.74433 11.6951 8.17905 11.6777 8.47363 11.918L8.53027 11.9697L10.4756 13.915L15.4473 8.49316L15.5019 8.43945Z'
          fill={fill}
        />
      ) : null}
    </svg>
  )
}

export default React.memo(Checkbox)
